export default theme => ({
  infoIcon: {
    width: '100%',
    marginBottom: theme.spacing(1),
  },
  title: {
    marginBottom: theme.spacing(1) / 2,
  },
})
